import { lenderAccessSignal } from './lenderAccess.signal';

export const handleSimpleLenderSearchChange = (e, lenders, selectedLenderIds = []) => {
  const { value } = e.target;
  const filteredLenders = lenders.filter((lender) =>
    lender.name.toLowerCase().includes(value.toLowerCase())
  );

  // Sort filtered lenders: selected ones first, then alphabetically
  const sortedFilteredLenders = filteredLenders.sort((a, b) => {
    const aSelected = selectedLenderIds.includes(a.id);
    const bSelected = selectedLenderIds.includes(b.id);
    
    // If one is selected and the other isn't, selected comes first
    if (aSelected && !bSelected) return -1;
    if (!aSelected && bSelected) return 1;
    
    // If both are selected or both are not selected, sort alphabetically
    return a.name.localeCompare(b.name);
  });

  lenderAccessSignal.update({ lendersFilteredBySearch: sortedFilteredLenders });
};

export default {};

